const cookieName = 'ERIGHTS';

export function hasRight() {
    return document.cookie.split(';').some((item) => item.trim().startsWith(`${cookieName}=`));
};

export function getAuthId() {
    return document.cookie.split(';').filter((item) => item.trim().startsWith(`ERIGHTS=`))[0];
};